module.exports = __webpack_public_path__ + "static/media/chen2025upper.96a61510.gif";